window.Products.Clothing.FittedTankTopLong = function() {};

window.Products.Clothing.FittedTankTopLong.inherits(window.Products.Clothing.FittedTankTop);
window.Products.Clothing.FittedTankTopLong.has_3d = true;
window.Products.Clothing.FittedTankTopLong.id = '65-long';
window.Products.Clothing.FittedTankTopLong.saveId = 65;
window.Products.Clothing.FittedTankTopLong.slug = 'fitted-tank-top-long';
window.Products.Clothing.FittedTankTopLong.dpi = 150;